import { Plugin } from 'vue';

import { preloader } from '@/directives';

export const preloaderPlugin: Plugin = {
	install(app) {
		app.directive('preloader', preloader);
	},
};
